module.exports = __webpack_public_path__ + "img/8_39.2232234c.png";